import { createValidationSchema, uuidField, } from "@for-it/domain-lib";
import { TenantEntity } from "../../entities/tenant.js";
import { TenantNotFoundError } from "../../errors/tenant-not-found-error.js";
const FALLBACK_PRIMARY = "#3B82F6";
const FALLBACK_SECONDARY = "#10B981";
export const getTenantBranding = {
    name: "getTenantBranding",
    description: "Returns the singleton branding row from the specified tenant's DB.",
    type: "query",
    isAuthRequired: true,
    payloadSchema: createValidationSchema({
        tenantId: uuidField({
            required: true,
            message: "Debe ingresar un ID de tenant válido",
        }),
    }),
    useCase: async ({ db, tenantConnectionResolver }, { tenantId }) => {
        const tenant = await db.findOne(TenantEntity, {
            where: { id: tenantId },
        });
        if (!tenant)
            return new TenantNotFoundError();
        const connection = await tenantConnectionResolver.open(tenant.dbName);
        try {
            const row = await connection.manager.query(`SELECT appName, logoUrl, faviconUrl, primaryColor, secondaryColor
                 FROM brandings
                 WHERE id = ?
                 LIMIT 1`, ["default"]);
            const first = Array.isArray(row) && row.length > 0 ? row[0] : null;
            if (!first) {
                // Fallback: branding row never seeded. Return tenant's
                // organizationName + reasonable defaults so the UI can
                // still render the modal without crashing.
                return {
                    appName: tenant.organizationName,
                    logoUrl: null,
                    faviconUrl: null,
                    primaryColor: FALLBACK_PRIMARY,
                    secondaryColor: FALLBACK_SECONDARY,
                };
            }
            return {
                appName: String(first.appName ?? tenant.organizationName),
                logoUrl: first.logoUrl ?? null,
                faviconUrl: first.faviconUrl ?? null,
                primaryColor: String(first.primaryColor ?? FALLBACK_PRIMARY),
                secondaryColor: String(first.secondaryColor ?? FALLBACK_SECONDARY),
            };
        }
        finally {
            await connection.release();
        }
    },
};
